import * as types from "./mutation_types";

export default {
  [types.DOMAINE_RESET](state) {
    Object.assign(state, {
      error: "",
      isLoading: false,
      items: null,
    });
  },

  [types.DOMAINE_SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.DOMAINE_SET_ITEMS](state, items) {
    Object.assign(state, { items });
  },

  [types.DOMAINE_TOGGLE_LOADING](state) {
    Object.assign(state, { isLoading: !state.isLoading });
  },
};
